import {useEffect, useState} from "react";
import {ThinCloseIcon} from "../../../components/icons/material-icons";
import {StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const AdminsEditWhoGetsConsentsSMSModal = (props: {
    active: boolean,
    closeHandler: any,
    whoGets: string,
    onDone: any,
    studentId: string,
    fatherTell: string,
    motherTell: string
}) => {
    const [who, setWho] = useState('default');
    useEffect(() => {
        const isActive = props.active;
        const _who = props.whoGets;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            setWho(_who);
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const saveChanges = (_who: string) => {
        const id = props.studentId;
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/students/who-get-consent/edit',
            {
                id: id,
                who: _who,
            },
            true,
            (d: {
                result: string,
                reason: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowSnackbar(
                    'ویرایش شد.',
                    'باشه',
                    5000,
                );
                props.onDone();
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')}>
                <div className="web-modal-header">
                    <div><b>ویرایش دریافت کننده رضایت‌نامه</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <label>دریافت کننده پیامک رضایت‌نامه:</label>
                        <button className={"techaran-radio-box" + (who === 'default' ? ' active' : '')}
                                onClick={() => {
                                    setWho('default');
                                    saveChanges('default');
                                }}>
                            <div><i/></div>
                            <span>
                                مطابق دریافت‌کننده پیامک عادی
                                <i>استفاده شده در حضورغیاب، بوفه و...</i>
                            </span>
                        </button>
                        <button className={"techaran-radio-box" + (who === 'father' ? ' active' : '')}
                                onClick={() => {
                                    setWho('father');
                                    saveChanges('father');
                                }}>
                            <div><i/></div>
                            <span>
                                توسط پدر
                                <i>{StringDigitsConvertToPersian(props.fatherTell.replaceAll('+98', '0'))}</i>
                            </span>
                        </button>
                        <button className={"techaran-radio-box" + (who === 'mother' ? ' active' : '')}
                                onClick={() => {
                                    setWho('mother');
                                    saveChanges('mother');
                                }}>
                            <div><i/></div>
                            <span>
                                توسط مادر
                                <i>{StringDigitsConvertToPersian(props.motherTell.replaceAll('+98', '0'))}</i>
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};